interface ParamProps {
  [key: string]: any
}

function createClassName(prefix: string, param: ParamProps = {}, classes = '') {
  const className = [prefix]
  const props = Object.keys(param)

  props.forEach((prop) => {
    if (param[prop]) {
      const propVal = param[prop]

      if (typeof propVal === 'boolean') {
        className.push([].concat(prefix, prop).join('-'))
      } else {
        className.push([].concat(prefix, prop, propVal).join('-'))
      }
    }
  })

  if (classes) className.push(classes)
  return className.join(' ')
}
export default createClassName
